import React, { createContext, ReactNode, RefObject, useContext, useMemo } from 'react'

interface FloatingStatusContextType {
  divContainerRef: RefObject<HTMLDivElement> | null
}

const FloatingStatusContext = createContext<FloatingStatusContextType>({ divContainerRef: null })

interface FloatingStatusProviderProps {
  children: ReactNode
  divContainerRef: RefObject<HTMLDivElement>
}

export const FloatingStatusProvider: React.FC<FloatingStatusProviderProps> = ({
  children,
  divContainerRef,
}) => {
  const memoizedRef = useMemo(() => divContainerRef, [divContainerRef])

  return (
    <FloatingStatusContext.Provider value={{ divContainerRef: memoizedRef }}>
      {children}
    </FloatingStatusContext.Provider>
  )
}

export const useFloatingStatusContext = () => {
  const context = useContext(FloatingStatusContext)
  return context
}
